import React from "react";
import "./Team.css";
const Team = (props) => {
  const teamPlayer = props.team;
  const totalBudget = teamPlayer.reduce(
    (initialValue, currentValue) => initialValue + currentValue.average_salary,
    0
  );
// Player Selection function
  const selectPlaeyr = teamPlayer.map((team) => {
    return (
      <div
        className="d-flex justify-content-between"
        key={teamPlayer.identifier}
      >
        <p>
          {" "}
          {team.first_name} {team.last_name}
        </p>
        <p className="float-right">$ {team.average_salary}</p>
      </div>
    );
  });

  return (
    //   Selected team player data is shown here 
    <div>
      <div className="d-flex justify-content-between">
        <h4>Number of Players</h4>
        <h4>{teamPlayer.length}</h4>
      </div>
      <div className="d-flex justify-content-between mb-3">
        <h4>Name</h4>
        <h4>Salary</h4>
      </div>
      <div className="selected-players">{selectPlaeyr}</div>
      <hr />
      <div className="d-flex justify-content-between">
        <h4>Total budget</h4>
        <h4>
          $ <span>{totalBudget}</span>{" "}
        </h4>
      </div>
    </div>
  );
};

export default Team;
